import { useState, useEffect } from "react";
import api from "../Service/api";
import "./CreateEmployee.css"; // Naya CSS file banayein

function CreateEmployee() {
  // --- Employee Create ---
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [loadingCreate, setLoadingCreate] = useState(false);

  // --- Employee List + Authority ---
  const [employees, setEmployees] = useState([]);
  const [authorities, setAuthorities] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState("");
  const [selectedAuthorities, setSelectedAuthorities] = useState([]);
  const [expandedMenus, setExpandedMenus] = useState({});
  const [loading, setLoading] = useState(false);

  // Authority Hierarchy Structure
  const authorityHierarchy = {
    "HOME": { label: "Home", icon: "🏠", children: {} },
    
    "PURCHASES": {
      label: "Purchases",
      icon: "🛒",
      children: {
        "ADD_PURCHASE": {
          label: "Add Purchase",
          children: {
            "ENTER_PURCHASE": { label: "Enter Purchase" },
            "VIEW_PURCHASE": { label: "View Purchase" }
          }
        },
        "RETURN_PURCHASE": {
          label: "Return Purchase",
          children: {
            "ENTER_PURCHASE_RETURN": { label: "Enter Return" },
            "VIEW_PURCHASE_RETURN": { label: "View Return" }
          }
        }
      }
    },

    "SALES": {
      label: "Sales",
      icon: "💰",
      children: {
        "ADD_SALE": {
          label: "Add Sale",
          children: {
            "ENTER_SALE": { label: "Enter Sale" },
            "VIEW_SALE": { label: "View Sale" },
            "VIEW_DELIVERY_CHALAN": { label: "View Delivery Chalan" }
          }
        },
        "RETURN_SALE": {
          label: "Return Sale",
          children: {
            "ENTER_SALE_RETURN": { label: "Enter Return" },
            "VIEW_SALE_RETURN": { label: "View Return" }
          }
        }
      }
    },

    "CATEGORIES": {
      label: "Categories",
      icon: "📋",
      children: {
        "PRODUCT": {
          label: "Product Categories",
          children: {
            "ADD_CATEGORY": { label: "Add Category" },
            "VIEW_CATEGORIES": { label: "View Categories" }
          }
        },
        "EXPENSE": {
          label: "Expense Categories",
          children: {
            "ADD & VIEW": { label: "Add & View" }
          }
        }
      }
    },

    "VENDORS&CUSTOMERS": {
      label: "Vendors & Customers",
      icon: "👥",
      children: {
        "VENDORS": {
          label: "Vendors",
          children: {
            "ADD_VENDOR": { label: "Add Vendor" },
            "VIEW_VENDORS": { label: "View Vendors" }
          }
        },
        "CUSTOMERS": {
          label: "Customers",
          children: {
            "ADD_CUSTOMER": { label: "Add Customer" },
            "VIEW_CUSTOMERS": { label: "View Customers" }
          }
        }
      }
    },

    "PAY BILLS": {
      label: "Pay Bills",
      icon: "💵",
      children: {
        "VENDOR_BILL": {
          label: "Vendor Bill",
          children: {
            "PAY_VENDOR_BILL": { label: "Pay Bill" },
            "VIEW_VENDOR_BILLS": { label: "View Bill" }
          }
        },
        "CUSTOMER_BILL": {
          label: "Customer Bill",
          children: {
            "RECEIVE_CUSTOMER_BILL": { label: "Receive Bill" },
            "VIEW_CUSTOMER_BILLS": { label: "View Bill" }
          }
        }
      }
    },

    "EXPENSES": {
      label: "Expenses",
      icon: "💸",
      children: {
        "ADD_EXPENSE": { label: "Add Expense" },
        "VIEW_EXPENSES": { label: "View Expenses" }
      }
    },

    "EMPLOYEES": {
      label: "Employees",
      icon: "👔",
      children: {
        "ADD_EMPLOYEE_DETAILS": { label: "Add Details" },
        "VIEW_EMPLOYEES": { label: "View Details" },
        "PAY_SALARY": { label: "Pay Salaries" },
        "VIEW_SALARIES": { label: "View Salaries" }
      }
    },

    "CLIENT REQUIREMENTS": {
      label: "Client Requirements",
      icon: "📝",
      children: {
        "ADD_REQUIREMENT": { label: "Add Requirement" },
        "VIEW_REQUIREMENTS": { label: "View Requirements" }
      }
    },

    "REPORTS": {
      label: "Reports",
      icon: "📊",
      children: {
        "STOCK_INVENTORY": { label: "Stock Inventory" },
        "CUSTOMER_LEDGER": { label: "Customer Ledger" },
        "VENDOR_LEDGER": { label: "Vendor Ledger" },
        "DAILY_INVOICE": { label: "Daily Invoice" }
      }
    },

    "PRODUCTION": {
      label: "Production",
      icon: "🏭",
      children: {
        "OWNER PRODUCTION": { label: "Add Product & Steps" },
        "EMPLOYEE_PRODUCTION": { label: "Employee Production Time" },
        "OWNER DASHBOARD": { label: "Production Report" }
      }
    },

    "ORDERS": {
      label: "Orders",
      icon: "📦",
      children: {
        "CREATE_ORDER": { label: "Create Order" },
        "VIEW_ORDERS": { label: "View Orders" }
      }
    },

    "EMPLOYEE LOGIN": {
      label: "Employee Login Management",
      icon: "🔐",
      children: {
        "CREATE_EMPLOYEE_LOGIN": { label: "Create Employee" },
        "MANAGE_AUTHORITIES": { label: "Manage Authorities" }
      }
    }
  };

  useEffect(() => {
    fetchEmployees();
    fetchAuthorities();
  }, []);

  const fetchEmployees = async () => {
    try {
      setLoading(true);
      const res = await api.get("/employee-login/getEmployees");
      
      let employeeData = [];
      if (res.data) {
        if (Array.isArray(res.data.additionalDetail)) {
          employeeData = res.data.additionalDetail;
        } else if (Array.isArray(res.data.employees)) {
          employeeData = res.data.employees;
        } else if (Array.isArray(res.data)) {
          employeeData = res.data;
        } else if (res.data.additionalDetail && typeof res.data.additionalDetail === 'object') {
          employeeData = Object.values(res.data.additionalDetail);
        }
      }
      
      setEmployees(employeeData || []);
    } catch (e) {
      console.error("Error fetching employees:", e);
      setEmployees([]);
    } finally {
      setLoading(false);
    }
  };

  const fetchAuthorities = async () => {
    try {
      const res = await api.get("/employee-login/getAuthorities");
      
      let authorityData = [];
      if (res.data) {
        if (Array.isArray(res.data.additionalDetail)) {
          authorityData = res.data.additionalDetail;
        } else if (Array.isArray(res.data.authorities)) {
          authorityData = res.data.authorities;
        } else if (Array.isArray(res.data)) {
          authorityData = res.data;
        } else if (res.data.additionalDetail && typeof res.data.additionalDetail === 'object') {
          authorityData = Object.values(res.data.additionalDetail);
        }
      }
      
      setAuthorities(authorityData || []);
    } catch (e) {
      console.error("Error fetching authorities:", e);
      setAuthorities([]);
    }
  };

  const createEmployee = async () => {
    if (!username || !password || !phoneNumber)
      return alert("Username, Phone & Password required");

    try {
      setLoadingCreate(true);
      await api.post("/employee-login/owner/employee", { username, password, phoneNumber });
      alert("Employee created successfully!");
      setUsername("");
      setPassword("");
      setPhoneNumber("");
      fetchEmployees();
    } catch (e) {
      console.error(e);
      alert("Error creating employee");
    } finally {
      setLoadingCreate(false);
    }
  };

  const toggleAuthority = (authorityId) => {
    setSelectedAuthorities(prev =>
      prev.includes(authorityId) 
        ? prev.filter(x => x !== authorityId) 
        : [...prev, authorityId]
    );
  };

  const toggleMenu = (menuPath) => {
    setExpandedMenus(prev => ({
      ...prev,
      [menuPath]: !prev[menuPath]
    }));
  };

  const assignAuthorities = async () => {
    if (!selectedEmployee) return alert("Select an employee");
    if (selectedAuthorities.length === 0) return alert("Select authorities");

    try {
      await api.post("/employee-login/assign-authorities", {
        employeeId: selectedEmployee,
        authorityIds: selectedAuthorities,
      });
      alert("Authorities assigned successfully!");
      setSelectedAuthorities([]);
      setSelectedEmployee("");
    } catch (e) {
      console.error(e);
      alert("Error assigning authorities");
    }
  };

  // Check if authority exists in the hierarchy and is available
  const isAuthorityAvailable = (authName) => {
    return authorities.some(a => 
      (a.authorityName || a.name)?.toUpperCase() === authName.toUpperCase()
    );
  };

  // Recursive function to render authority tree
  const renderAuthorityTree = (node, parentPath = "") => {
    if (!node) return null;

    return Object.entries(node).map(([key, value]) => {
      const currentPath = parentPath ? `${parentPath}.${key}` : key;
      const hasChildren = value.children && Object.keys(value.children).length > 0;
      const isExpanded = expandedMenus[currentPath];
      
      // Find the actual authority ID from the authorities list
      const authorityObj = authorities.find(a => 
        (a.authorityName || a.name)?.toUpperCase() === key.toUpperCase()
      );
      const authorityId = authorityObj?.authorityId || authorityObj?.id;
      const isAvailable = !!authorityId;
      const isSelected = authorityId ? selectedAuthorities.includes(authorityId) : false;

      // Don't render if authority doesn't exist in the list and has no children
      if (!isAvailable && !hasChildren) return null;

      return (
        <div key={key} className="authority-tree-item">
          <div 
            className={`authority-row ${hasChildren ? 'has-children' : ''} ${isSelected ? 'selected' : ''} ${!isAvailable ? 'disabled' : ''}`}
            style={{ paddingLeft: `${parentPath.split('.').filter(p => p).length * 20}px` }}
          >
            {hasChildren && (
              <span 
                className="expand-icon" 
                onClick={() => toggleMenu(currentPath)}
              >
                {isExpanded ? '▼' : '►'}
              </span>
            )}
            
            {!hasChildren && <span className="expand-icon-placeholder"></span>}
            
            {isAvailable && (
              <input
                type="checkbox"
                checked={isSelected}
                onChange={() => toggleAuthority(authorityId)}
                id={`auth-${key}`}
                disabled={!isAvailable}
              />
            )}
            
            {!isAvailable && <span className="checkbox-placeholder"></span>}
            
            <label 
              htmlFor={`auth-${key}`}
              className={`authority-label ${!isAvailable ? 'text-muted' : ''}`}
              onClick={(e) => {
                if (hasChildren && e.target.tagName !== 'INPUT') {
                  toggleMenu(currentPath);
                }
              }}
            >
              {value.icon && <span className="authority-icon">{value.icon}</span>}
              {value.label || key}
              {!isAvailable && <span className="not-available-badge">(not available)</span>}
            </label>
          </div>

          {hasChildren && isExpanded && (
            <div className="authority-children">
              {renderAuthorityTree(value.children, currentPath)}
            </div>
          )}
        </div>
      );
    });
  };

  const getSafeEmployees = () => {
    return Array.isArray(employees) ? employees : [];
  };

  return (
    <div className="create-employee-container">
      <h1 className="page-title">Employee Management</h1>

      {/* Create Employee Form */}
      <div className="create-employee-card">
        <h2 className="section-title">Create New Employee</h2>
        <div className="form-grid">
          <input
            type="text"
            placeholder="Username"
            value={username}
            onChange={e => setUsername(e.target.value)}
            className="form-input"
          />
          <input
            type="text"
            placeholder="Phone Number"
            value={phoneNumber}
            onChange={e => setPhoneNumber(e.target.value)}
            className="form-input"
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            className="form-input"
          />
          <button
            onClick={createEmployee}
            disabled={loadingCreate}
            className="btn btn-primary"
          >
            {loadingCreate ? "Creating..." : "Create Employee"}
          </button>
        </div>
      </div>

      {/* Assign Authorities Section */}
      <div className="assign-authorities-card">
        <h2 className="section-title">Assign Authorities to Employee</h2>

        {loading ? (
          <div className="loading-spinner">Loading employees...</div>
        ) : (
          <>
            <select
              value={selectedEmployee}
              onChange={e => setSelectedEmployee(e.target.value)}
              className="employee-select"
            >
              <option value="">Select Employee</option>
              {getSafeEmployees().map(emp => (
                <option key={emp.employeeId || emp.id} value={emp.employeeId || emp.id}>
                  {emp.username || emp.name || `Employee ${emp.employeeId || emp.id}`}
                </option>
              ))}
            </select>

            {selectedEmployee && (
              <>
                <div className="authorities-tree-container">
                  <h3 className="tree-title">Authorities Tree</h3>
                  <div className="tree-scroll">
                    {renderAuthorityTree(authorityHierarchy)}
                  </div>
                </div>

                <div className="selected-summary">
                  <h4>Selected Authorities: {selectedAuthorities.length}</h4>
                  <div className="selected-tags">
                    {selectedAuthorities.map(id => {
                      const auth = authorities.find(a => 
                        (a.authorityId || a.id) === id
                      );
                      return auth && (
                        <span key={id} className="selected-tag">
                          {auth.authorityName || auth.name}
                          <button onClick={() => toggleAuthority(id)}>×</button>
                        </span>
                      );
                    })}
                  </div>
                </div>

                <button
                  onClick={assignAuthorities}
                  disabled={selectedAuthorities.length === 0}
                  className="btn btn-success assign-btn"
                >
                  Assign Authorities
                </button>
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
}

export default CreateEmployee;